
import {SET_INTERFACE_INFO , SET_PROFILE_SLIDE_PANE } from "../../actions/app.type";

const initialState = {
    show_slide_pane :false,
    show_pop_up: false,
    show_profile_slide_pane: false,
};

export default (state = initialState, action:{type:string,payload:object,}) => {
    switch (action.type) {
    case SET_INTERFACE_INFO:
        return { ...state, ...action.payload};
    case SET_PROFILE_SLIDE_PANE :
        return{...state,show_profile_slide_pane:action.payload};
    default:
        return state;
    }
};
